<template>
  <form @submit.prevent="">
    <div class="row align-items-end">
      <div class="col-md-5">
        <label for="aip-uuid">DIP UUID</label>
        <input
          type="text"
          class="form-control"
          style="width: 100%"
          id="aip-uuid"
        />
      </div>
      <div class="col-md-5">
        <label for="audit-event-type">Audit Event Type</label>
        <select id="audit-event-type" class="form-select" style="width: 100%">
          <option selected>Select...</option>
          <option>Download</option>
          <option>Delete</option>
        </select>
      </div>
      <div class="col-md-1">
        <button
          type="submit"
          class="btn btn-clear btn-outline-secondary"
          style="width: 100%"
        >
          Clear All
        </button>
      </div>
      <div class="col-md-1">
        <button
          type="submit"
          class="btn btn-search btn-primary"
          style="width: 100%"
        >
          Search
        </button>
      </div>
    </div>
  </form>
</template>
